import React, {useEffect, useRef} from 'react';
import '@/App.css';
import { useVideoData } from '@/v2/pages/Lesson/hooks/useVideoData';
import { useVideoInteractions } from '@/v2/hooks/useVideoInteractions';
import { useFilters } from '@/v2/hooks/useFilters';
import FilterSection from '@/v2/pages/Lesson/components/FilterSection';
import VideoGrid from '@/v2/pages/Lesson/components/VideoGrid';
import MobileViewFilters from '@/v2/pages/Lesson/components/MobileViewFilters';
import { usePagination } from '@/v2/hooks/usePagination';
import CustomPagination from '@/component/Pagination/CustomPagination';
import AddToPlayListModal from '@/component/playlist/personal-playlist/AddToPlayListModal';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import NoVideosFoundSection from '../../components/NoVideosFoundSection';
import {getUniqueTagsFromVideos} from '@/utils/getUniqueTagsFromVideos';

export const Lesson = () => {
	const categoryId = '6541e9cdf1f99641d644a357';

	// Custom hooks to separate business logic
	const userData = useAtomValue(userInfoAtom);

	const {
		currentPage,
		setCurrentPage,
		itemsPerPage,
		// totVideos,
		handlePageChange
	} = usePagination();

	const {
		tags,
		instructors,
		setInstructors,
		products,
		selectedTags,
		setSelectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts,
		sortby,
		handleFilterChange,
		handleApplyFilter,
		handleResetFilter,
		isFilterModalOpen,
		handleOpenFilterModal,
		handleCloseFilterModal
	} = useFilters();

	const { responseData, handleShuffle, setResponseData, totVideos } = useVideoData({
		categoryId,
		currentPage,
		itemsPerPage,
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts,
		sortby
	});
	useEffect(() => {
			if (responseData?.length > 0 && instructors.length === 0) {
				setInstructors([
					...new Set(
						responseData[0]?.videos
							.filter(video => video.instructor !== undefined && video.instructor !== null)
							.map(video => video.instructor)
					)
				]);
			}
	}, [responseData, instructors.length]);
	const {
		handleSubmit,
		handlePlayerVideo,
		handelSubmitPlaylist,
		savedVideoIds,
		modal,
		setModal,
		videoData2,
		setVideoData2
	} = useVideoInteractions({ responseData, setResponseData });

	const initialFocusRef = useRef([]);

	const uniqueTags = getUniqueTagsFromVideos(responseData[0]?.videos, initialFocusRef);
	
	

	return (
		<>
			{/* Mobile View Filters */}
			<MobileViewFilters
				handleOpenFilterModal={handleOpenFilterModal}
				isFilterModalOpen={isFilterModalOpen}
				handleFilterChange={handleFilterChange}
				sortBy={sortby}
				tags={tags}
				selectedTags={selectedTags}
				selectedDurations={selectedDurations}
				selectedLevels={selectedLevels}
				selectedInstructors={selectedInstructors}
				selectedProducts={selectedProducts}
				handleApplyFilter={handleApplyFilter}
				handleResetFilter={handleResetFilter}
				handleCloseFilterModal={handleCloseFilterModal}
				instructors={instructors}
				products={products}
			/>

			<div>
				<div className="tab-content fade-in" style={{ minHeight: '100vh' }}>
					<div id="menu2" className="tab-pane fade active show">
						{responseData?.map((category, index) => (
							<div key={index} id={category?.name?.split(' ')[0]}>
								{/* Desktop Filter Bar */}
								<FilterSection
									category={category}
									handleOpenFilterModal={handleOpenFilterModal}
									handleFilterChange={handleFilterChange}
									sortby={sortby}
									isFilterModalOpen={isFilterModalOpen}
									tags={tags} 
									selectedTags={selectedTags}
									selectedDurations={selectedDurations}
									selectedLevels={selectedLevels}
									handleApplyFilter={handleApplyFilter}
									handleResetFilter={handleResetFilter}
									handleCloseFilterModal={handleCloseFilterModal}
									selectedInstructors={selectedInstructors}
									instructors={instructors}
									products={products}
									selectedProducts={selectedProducts}
									handleShuffle={() => handleShuffle(category?.id)}
								/>
								{category?.videos.length === 0 && (
									<NoVideosFoundSection/>
								)}
								{/* Video Grid */}
								<VideoGrid
									videos={category?.videos}
									isLoggedIn={userData.token ? true : false}
									handlePlayerVideo={handlePlayerVideo}
									handleSubmit={handleSubmit}
									handelSubmitPlaylist={handelSubmitPlaylist}
									savedVideoIds={savedVideoIds}
									selectedTags={selectedTags}
									setSelectedTags={setSelectedTags}
									modal={modal}
									setModal={setModal}
									setVideoData={setVideoData2}
									selectTagCallback={tag => {
										setSelectedTags(tags => {
											if (tags.includes(tag._id)) {
												return tags.filter(t => t !== tag._id);
											}
											return [...tags, tag._id];
										});
									}}
								/>

								{/* Pagination */}
								<CustomPagination totalPages={totVideos} currentPage={currentPage} onPageChange={handlePageChange} />
							</div>
						))}
					</div>
				</div>

				{/* Playlist Modal */}
				<AddToPlayListModal
					modal={modal}
					setModal={setModal}
					activeObject={videoData2}
					viewData={[]} //TODO: Replace empty array with actual videos if needed
				/>
			</div>
		</>
	);
};
